import { BaseEntityDto, DocumentStatus, DocumentTypeEnum } from '@fleet-beat/core';

export interface DocumentDto extends BaseEntityDto {
  id?: string;
  itemType?: 'driver' | 'truck';
  itemId?: string;
  contentType?: string;
  documentId?: string;
  description?: string;
  expirationState?: 'expired';
  title?: string;
  url?: string;
  expirationDate?: string;
  status?: DocumentStatus;
  type?: DocumentTypeEnum;
}
